import axios from "axios";

export const getAccountByUserId = async (userId) => {
  let resp = await axios.get(
    process.env.REACT_APP_BACKEND_URL + `api/users/${userId}?populate=*`
  );

  return resp.data.accounts[0];
};


